import { navigate } from '~/common';
import { LOGGED_IN_HOME_PATHNAME } from '~/src/common/routes';
import { useCurrentUser } from '~/src/common/user';

import { useRunOnlyOnce } from './useRunOnlyOnce';

export const useRedirectIfLoggedIn = (path = LOGGED_IN_HOME_PATHNAME) => {
  const { isLoggedIn, loading } = useCurrentUser();
  const redirectIfLoggedInOnce = useRunOnlyOnce(() => {
    if (isLoggedIn) {
      navigate(path, { replace: true });
    }
  }, [loading, isLoggedIn]);
  redirectIfLoggedInOnce();
  return {
    /**
     * using "loading" leads to first render, so the user sees the content flashing
     * */
    loading, // @deprecated
    hasAuthorizationChecked: !loading && !isLoggedIn,
  };
};
